module.exports = __webpack_public_path__ + "img/01_no.233e3346.svg";